import { useState, useEffect } from "react";
import { EVENT } from "../config";

export function useCountdown() {
  const [state, setState] = useState(() => calculate());

  useEffect(() => {
    const id = setInterval(() => setState(calculate()), 1000);
    return () => clearInterval(id);
  }, []);

  return state;
}

function calculate() {
  const now = Date.now();
  const earlyBird = EVENT.earlyBirdDeadline.getTime();
  const event = EVENT.eventStart.getTime();

  let target, label, isEarlyBird;

  if (now < earlyBird) {
    target = earlyBird;
    label = "Early bird ends in";
    isEarlyBird = true;
  } else if (now < event) {
    target = event;
    label = "Show starts in";
    isEarlyBird = false;
  } else {
    return { days: 0, hours: 0, mins: 0, secs: 0, label: "The show has started!", isEarlyBird: false, isOver: true };
  }

  const diff = target - now;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
    label,
    isEarlyBird,
    isOver: false,
  };
}
